import axios from 'axios';
import * as Sentry from '@sentry/vue';
import { showToast } from '@inscribe/signal';

export default {
  state: {
    list: [],
    loading: true,
    pages: undefined,
    total: undefined,
  },
  mutations: {
    setSessions(state, response) {
      state.pages = response.metadata.pagination.number_of_pages;
      state.total = response.metadata.pagination.total;
      state.list = response.data;
    },
    setSessionsLoading(state, loadingState) {
      state.loading = loadingState;
    },
  },
  actions: {
    async getSessions({ commit }, params) {
      try {
        commit('setSessionsLoading', true);

        const response = await axios.get('api/v2/collect/sessions/', {
          params,
        });
        commit('setSessions', response.data);
        commit('setSessionsLoading', false);
      } catch (error) {
        showToast({
          title: 'Error loading the Collect Session.',
          text: error?.response?.data?.message,
          isError: true,
        });
      }
    },

    async getSingleSession({}, id) {
      try {
        const response = await axios.get(`api/v2/collect/sessions/${id}`);
        return response;
      } catch (error) {
        Sentry.captureMessage('Error loading single collect session', error);
      }
    },
  },
};
